/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { EMPTY_STRING } from '@common/tech-shared';
import { booleanAttribute, Component, EventEmitter, Input, numberAttribute, Output, QueryList } from '@angular/core';
import { InstantSearchComponent, InstantSearchQuery, SearchResultItemComponent, SearchResultLayerVariants } from '@ods/system';
import { FormControlEditorAbstractComponent } from '../form/formcontrol-editor.abstract.component';

@Component({
  selector: 'odc-instant-search-editor',
  imports: [InstantSearchComponent],
  templateUrl: './instant-search-editor.component.html',
})
export class InstantSearchEditorComponent extends FormControlEditorAbstractComponent {
  @Input() searchResultItemList: QueryList<SearchResultItemComponent>;
  @Input({ required: true }) label: string;
  @Input() placeholder: string = EMPTY_STRING;
  @Input() headerText: string = EMPTY_STRING;
  @Input({ transform: booleanAttribute }) focusOnSearchField: boolean = false;
  @Input({ transform: booleanAttribute }) showLabel: boolean = false;
  @Input({ transform: numberAttribute }) previewSearchMinLength: number = 2;
  @Input() variant: SearchResultLayerVariants['variant'];

  @Output() searchResultsClosed: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() inputClicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() searchQueryChanged: EventEmitter<InstantSearchQuery> = new EventEmitter<InstantSearchQuery>();
  @Output() searchQueryCleared: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}
